"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2570],{

/***/ 82570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wk": function() { return /* reexport */ GetAgencyAgentsDetailGateway; },
  "sK": function() { return /* reexport */ GetAgentDetailGateway; },
  "JG": function() { return /* reexport */ GetApartRanksGateway; },
  "a7": function() { return /* reexport */ GetDisplayShopListGateway; },
  "lM": function() { return /* reexport */ GetSearchAgentsGateway; },
  "Hh": function() { return /* reexport */ GetShopClusterListGateway; },
  "N5": function() { return /* reexport */ GetShopConsultantGateway; },
  "UU": function() { return /* reexport */ GetShopDetailGateway; },
  "BV": function() { return /* reexport */ GetShopGunGusGateway; },
  "mV": function() { return /* reexport */ GetShopListGateway; },
  "py": function() { return /* reexport */ GetShopSidoGateway; },
  "x1": function() { return /* reexport */ GetSrShopListGateway; },
  "mk": function() { return /* reexport */ PostGeoLocationGateway; },
  "Kv": function() { return /* reexport */ flattenWorkAvailableAreas; },
  "Fu": function() { return /* reexport */ getExtraAreaCount; },
  "I2": function() { return /* reexport */ getRepresentativeAreaText; }
});

// UNUSED EXPORTS: GetSearchAgentsBadgesGateway, getTotalAreaCount, hello

;// CONCATENATED MODULE: ../../shared/shop/src/utils/consultArea.ts
/**
 * 시도 그룹핑 구조를 "시도 시구" 평면 문자열 배열로 변환한다.
 * (기존 평면 렌더 소비처의 하위호환 유지용)
 * 시구가 없는 시도(예: 세종)는 시도명만 반환한다.
 */ var flattenWorkAvailableAreas = function(areas) {
    return (areas !== null && areas !== void 0 ? areas : []).flatMap(function(area) {
        return area.sigu.length ? area.sigu.map(function(sigu) {
            return "".concat(area.sido, " ").concat(sigu);
        }) : [
            area.sido
        ];
    });
};
/**
 * 전체 상담가능 지역(군구) 총 개수.
 * 시구가 없는 시도(세종 등)는 시 단위로 1개 계수한다.
 */ var getTotalAreaCount = function(areas) {
    return (areas !== null && areas !== void 0 ? areas : []).reduce(function(count, area) {
        return count + (area.sigu.length || 1);
    }, 0);
};
/**
 * 대표 상담가능 지역 텍스트 (API 순서상 top1: 첫 시도 + 첫 시구).
 * 시구가 없으면 시도명만 반환한다.
 */ var getRepresentativeAreaText = function(areas) {
    var first = areas === null || areas === void 0 ? void 0 : areas[0];
    if (!first) return "";
    return first.sigu.length ? "".concat(first.sido, " ").concat(first.sigu[0]) : first.sido;
};
/**
 * 대표 지역을 제외한 나머지 지역 수 ("외 N개 지역"의 N).
 */ var getExtraAreaCount = function(areas) {
    return Math.max(0, getTotalAreaCount(areas) - 1);
};

;// CONCATENATED MODULE: ../../shared/shop/src/utils/index.ts
var hello = function() {
    return "hello";
};


// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(1861);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../.yarn/cache/query-string-npm-7.1.1-55c6f31f52-b227d1f588.zip/node_modules/query-string/index.js
var query_string = __webpack_require__(46757);
;// CONCATENATED MODULE: ../../shared/shop/src/adapter/gateway/search.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}


// 시도 목록 API
var GetShopSidoGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetShopSidoGateway(httpClient) {
        _classCallCheck(this, GetShopSidoGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetShopSidoGateway.prototype;
    _proto.exec = function exec(_req) {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/shop-service/api/v1/shops/sidos")
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetShopSidoGateway;
}();
// 군구 목록 API
var GetShopGunGusGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetShopGunGusGateway(httpClient) {
        _classCallCheck(this, GetShopGunGusGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetShopGunGusGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            var query;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        query = query_string.stringify(req);
                        _ctx.next = 3;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/shop-service/api/v1/shops/gungus?").concat(query)
                        });
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetShopGunGusGateway;
}();
// 매장 목록 API
var GetShopListGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetShopListGateway(httpClient) {
        _classCallCheck(this, GetShopListGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetShopListGateway.prototype;
    _proto.exec = function exec(req) {
        var query = query_string.stringify(req);
        return this.httpClient.request({
            method: "GET",
            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/shop-service/api/v1/shops?").concat(query)
        }).then(function(result) {
            if (result.code === 200) {
                return result;
            } else {
                throw new Error(result.message);
            }
        });
    };
    return GetShopListGateway;
}();
// (남한 전경) 클러스터 목록 API
var GetShopClusterListGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetShopClusterListGateway(httpClient) {
        _classCallCheck(this, GetShopClusterListGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetShopClusterListGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            var query;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        query = query_string.stringify(req);
                        _ctx.next = 3;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/shop-service/api/v1/shops/clusters?").concat(query)
                        });
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetShopClusterListGateway;
}();
var GetDisplayShopListGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetDisplayShopListGateway(httpClient) {
        _classCallCheck(this, GetDisplayShopListGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetDisplayShopListGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            var query;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        query = query_string.stringify(req);
                        _ctx.next = 3;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/shop-service/api/v1/shops/goods/display?").concat(query)
                        });
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetDisplayShopListGateway;
}();

;// CONCATENATED MODULE: ../../shared/shop/src/adapter/gateway/detail.ts
function detail_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function detail_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                detail_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                detail_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function detail_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

// 매장 상세 API
var GetShopDetailGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetShopDetailGateway(httpClient) {
        detail_classCallCheck(this, GetShopDetailGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetShopDetailGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return detail_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/shop-service/api/v1/shops/").concat(req === null || req === void 0 ? void 0 : req.shopId, "?typeValue=").concat(req === null || req === void 0 ? void 0 : req.typeValue)
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetShopDetailGateway;
}();
// 최다 시공 아파트 목록 API
var GetApartRanksGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetApartRanksGateway(httpClient) {
        detail_classCallCheck(this, GetApartRanksGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetApartRanksGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return detail_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/shop-service/api/v1/shops/").concat(req.shopId, "/apart-ranks")
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetApartRanksGateway;
}();
// 전문 상담사 목록 API
var GetShopConsultantGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetShopConsultantGateway(httpClient) {
        detail_classCallCheck(this, GetShopConsultantGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetShopConsultantGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return detail_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/shop-service/api/v1/shops/").concat(req.shopId, "/consultants?code=").concat(req.code)
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetShopConsultantGateway;
}();

;// CONCATENATED MODULE: ../../shared/shop/src/adapter/gateway/remodeling-start.ts
function remodeling_start_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function remodeling_start_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                remodeling_start_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                remodeling_start_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function remodeling_start_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}


var GetSrShopListGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetSrShopListGateway(httpClient) {
        remodeling_start_classCallCheck(this, GetSrShopListGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetSrShopListGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return remodeling_start_asyncToGenerator(runtime_default().mark(function _callee() {
            var query;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        query = query_string.stringify(req);
                        _ctx.next = 3;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/shop-service/api/v1/sr/shops?").concat(query)
                        });
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetSrShopListGateway;
}();

;// CONCATENATED MODULE: ../../shared/shop/src/adapter/gateway/geo-location.ts
function geo_location_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function geo_location_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                geo_location_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                geo_location_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function geo_location_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var PostGeoLocationGateway = /*#__PURE__*/ function() {
    "use strict";
    function PostGeoLocationGateway(httpClient) {
        geo_location_classCallCheck(this, PostGeoLocationGateway);
        this.httpClient = httpClient;
    }
    var _proto = PostGeoLocationGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return geo_location_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "POST",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/shop-service/api/v1/shops/geoLocation"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return PostGeoLocationGateway;
}();

;// CONCATENATED MODULE: ../../shared/shop/src/adapter/gateway/agent.ts
function agent_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function agent_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                agent_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                agent_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function agent_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var GetSearchAgentsBadgesGateway = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function GetSearchAgentsBadgesGateway(httpClient) {
        agent_classCallCheck(this, GetSearchAgentsBadgesGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetSearchAgentsBadgesGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return agent_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/shop-service/api/v1/agents/badges"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetSearchAgentsBadgesGateway;
}()));
var GetSearchAgentsGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetSearchAgentsGateway(httpClient) {
        agent_classCallCheck(this, GetSearchAgentsGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetSearchAgentsGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return agent_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/shop-service/api/v1/agents"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetSearchAgentsGateway;
}();
var GetAgentDetailGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetAgentDetailGateway(httpClient) {
        agent_classCallCheck(this, GetAgentDetailGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetAgentDetailGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return agent_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/shop-service/api/v1/agents/").concat(req.agentCode)
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetAgentDetailGateway;
}();
var GetAgencyAgentsDetailGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetAgencyAgentsDetailGateway(httpClient) {
        agent_classCallCheck(this, GetAgencyAgentsDetailGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetAgencyAgentsDetailGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return agent_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/shop-service/api/v1/agencies/").concat(req.agencyCode, "/agents"),
                            body: {
                                agencyType: req.agencyType
                            }
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetAgencyAgentsDetailGateway;
}();

;// CONCATENATED MODULE: ../../shared/shop/src/adapter/gateway/index.ts






;// CONCATENATED MODULE: ../../shared/shop/src/adapter/index.ts


;// CONCATENATED MODULE: ../../shared/shop/src/index.ts






/***/ })

}]);